import { defineSetting } from '../settingsRegistry';

declare module '../settingsRegistry' {
  interface Settings {
    /** Lane CAMERA-PITCH experiment: the camera tilts up a little while flying with qinggong (render/flightTilt.ts). */
    flightTilt: boolean;
  }
}

defineSetting({
  key: 'flightTilt',
  default: true,
  order: 350,
  menu: { group: 'visual', label: 'กล้องเงยขึ้นเล็กน้อยขณะเหาะ' },
});
